import { VNode, h } from "vue";

export function vnodeToString(vnode: any) {
  if (
    ["string", "boolean", "undefined", "null", "number"].includes(typeof vnode)
  ) {
    return vnode;
  }
  const attrs = Object.keys(vnode.attrs || {})
    .map((key) => `${key}="${vnode.attrs[key]}"`)
    .join(" ");
  const children = (vnode.children || []).map(vnodeToString).join("");
  return `<${vnode.tag} ${attrs}>${children}</${vnode.tag}>`;
}

export const getElementAttrs = (node: HTMLElement) => {
  const attrs: Record<string, string> = {};
  if (node.attributes) {
    for (let i = 0, atts = node.attributes, n = atts.length; i < n; i++) {
      const att = atts[i];
      if (att.nodeName && att.nodeValue) {
        attrs[att.nodeName] = att.nodeValue;
      }
    }
  }
  // for (const attr of node.attributes) attrs[attr.name] = attr.value;
  return attrs;
};

export const elementsToVNodes = (
  elements: HTMLElement | HTMLElement[]
): VNode[] => {
  if (!Array.isArray(elements)) {
    elements = [elements];
  }
  return elements.map((element) => {
    // 3 is #text, not sure how else to build this one
    if (element.nodeType === 3) {
      return h("span", element.nodeValue || "");
    }
    if (element.childNodes && element.childNodes.length) {
      return h(
        element.tagName,
        getElementAttrs(element),
        elementsToVNodes(element.childNodes as unknown as HTMLElement[])
      );
    } else {
      return h(element.tagName, getElementAttrs(element), element.innerHTML);
    }
  });
};

export const stringToVNodes = (html: string) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return elementsToVNodes(div.childNodes as unknown as HTMLElement[]);
};
